import {isStatusInBearbeitung} from '../../../../models/enums/TSVersicherungsbeitragStatus';
import TSVersicherungsbeitrag from '../../../../models/TSVersicherungsbeitrag';
import TSZahlungsauftragDTO from '../../../../models/TSZahlungsauftragDTO';
import DVBernUtil from '../../../../utils/DVBernUtil';

declare let require: any;
declare let angular: any;

import IComponentOptions = angular.IComponentOptions;
import IFormController = angular.IFormController;
import ILogService = angular.ILogService;
import IQService = angular.IQService;
import IScope = angular.IScope;
import ITranslateService = angular.translate.ITranslateService;

let styles = require('./dv-versicherungsbeitragBeitrag.scss');
let template = require('./dv-versicherungsbeitragBeitrag.html');

export class DvVersicherungsbeitragBeitragComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = DvVersicherungsbeitragBeitragController;
    controllerAs: string = 'vm';
    bindings: any = {
        versicherungsbeitrag: '<',
        zahlungsauftrag: '<',
        beitragReadonly: '<',
        onBeitragSave: '&',
        onBeitragCancel: '&'
    };

    require: any = {parentForm: '?^form'};
}

export class DvVersicherungsbeitragBeitragController {

    versicherungsbeitrag: TSVersicherungsbeitrag;
    zahlungsauftrag: TSZahlungsauftragDTO;
    beitragReadonly: boolean;
    form: IFormController;
    schadenfallId: string;
    readonly: boolean;
    betragVorschlag: number;

    onBeitragSave: () => void;
    onBeitragCancel: () => void;
    prozentsatz: number;

    static $inject = ['DVBernUtil', '$q', '$scope', '$translate', '$log'];

    /* @ngInject */
    constructor(private dvBernUtil: DVBernUtil,
                private  $q: IQService,
                private $scope: IScope, private $translate: ITranslateService, private $log: ILogService) {
    }

    $onInit() {
        if (!this.versicherungsbeitrag) {
            this.versicherungsbeitrag = new TSVersicherungsbeitrag();
            this.$log.warn('initialized versicherungsbeitrag to edit directly in view, should pass versicherungsbeitrag to edit along');
        }
        this.readonly = !isStatusInBearbeitung(this.versicherungsbeitrag.status);

        this.updateBeitrag();
        // wenn ermittelter schaden oder der beitrag selber aendert muessen wir neu berechnen
        this.$scope.$watch(() => {
            return this.versicherungsbeitrag.ermittelterSchaden;
        }, (newValue, oldValue) => {
            this.updateBeitrag();
        });

        this.$scope.$watch(() => {
            return this.versicherungsbeitrag.beitrag;
        }, (newValue, oldValue) => {
            this.updateBeitrag();
        });
    }

    public updateBeitrag(): void {
        this.updateVorschlag();
        // vorschlag wird nur bei neuen versBeitr.beitrag gesetzt
        if (!this.readonly && this.versicherungsbeitrag.beitrag && this.versicherungsbeitrag.beitrag.isNew()) {
            this.versicherungsbeitrag.beitrag.beitrag = this.betragVorschlag;
        }
    }

    private updateVorschlag() {
        this.prozentsatz = parseFloat(this.versicherungsbeitrag.versicherung.prozentsatz);
        let betragVorschl = parseFloat(this.versicherungsbeitrag.getAnrechenbarerSchaden(this.prozentsatz).toFixed(2));
        this.betragVorschlag = Math.max(betragVorschl, 0); //vorschlag kann nicht kleiner 0 sein
    }

    public cancel() {
        if (angular.isFunction(this.onBeitragCancel)) {
            this.onBeitragCancel();
        } else {
            this.$log.warn('no cancel function was passed, doing nothing')
        }

    }

    public save() {

        if (this.isModelValid()) {
            if (angular.isFunction(this.onBeitragSave())) {
                this.onBeitragSave();
            } else {
                this.$log.warn('no save function was passed, doing nothing')
            }
        } else {
            this.$log.warn('beitrag form is not valid');
        }

    }

    public isModelValid(): boolean {
        if (!this.form.$valid) {
            DVBernUtil.focusFirstInvalidInput()
        }
        return this.form.$valid;
    }

    public isBeitragReadonly(): boolean {
        return this.beitragReadonly;
    }

}



// WEBPACK FOOTER //
// ./src/app/versicherungsbeitraege/component/versicherungsbeitragBeitragView/component/dv-versicherungsbeitragBeitrag.ts